import { useEffect, useState } from "react";
import { usePostApiRequestAxios } from "../Redux/Hooks/usePostApi";
import { AxiosError, AxiosResponse } from "axios";
import { IRequestParamsPost } from "../Interfaces/IRequestParams";
import { FileUploadParameters } from "../Types/FileUpload";
import { ApiCallStatus, ApiCallStatusStates } from "../Types/ApiStatus";
import { errorToast, successToast } from "../Service-Utils/toastMessage";
import { extractErrorMessage } from "./messageHelper";

export const useFileUpload = ({endpoint, file, contentType, showDefaultSuccessToast = true, showDefaultErrorToast = true, onError, onSuccess}: FileUploadParameters): {
    fileUploadStatus: ApiCallStatus
} => {
    const [fileUploadStatus, setFileUploadStatus] = useState<ApiCallStatus>(ApiCallStatusStates.LOADING);

    function onSuccessHandler(response: AxiosResponse) {
        showDefaultSuccessToast && successToast(`File ${file.name} successfully uploaded.`);
        setFileUploadStatus(ApiCallStatusStates.SUCCESS);

        if (onSuccess) {
            onSuccess(response);
        }
    };

    function onErrorHandler(error: AxiosError) {
        showDefaultErrorToast && errorToast(extractErrorMessage(error), 8000);
        setFileUploadStatus(ApiCallStatusStates.ERROR);

        if (onError) {
            onError(error);
        }
    };

    const paramsPorPost: IRequestParamsPost = {
        onError(error: AxiosError) {
            onErrorHandler(error);
        },
        onSuccess(res: any) {
            if (res.isAxiosError) {
                onErrorHandler(res);

                return;
            }

            onSuccessHandler(res);
        }
    };

    const {
        mutate,
        isSuccess: isFileUploadSuccess,
        isError: isFileUploadError,
    } = usePostApiRequestAxios(paramsPorPost);

    useEffect(() => {
        if (file) {
            const formData = new FormData();
            formData.append("file", file);

            const postRequestParams = {
                headers: {
                    ContentType: contentType,
                    Accept: "application/json"
                },
                method: "POST",
                payload: formData,
                service: endpoint
            };

            setFileUploadStatus(ApiCallStatusStates.LOADING);
            mutate(postRequestParams);
        }
    }, [file]);

    useEffect(() => {
        isFileUploadSuccess && setFileUploadStatus(ApiCallStatusStates.SUCCESS);
        isFileUploadError && setFileUploadStatus(ApiCallStatusStates.ERROR);
    }, [isFileUploadSuccess, isFileUploadError]);

    return {
        fileUploadStatus
    };
};